import axios from '../api/axios';
import { AuthModel, UserModel } from './_models';

const GET_USER_URL = '/app/account';
const LOGIN_URL = '/login';
const REQUEST_PASSWORD_URL = 'forgot_password';
const REQUEST_RESET_URL = '/reset_password';

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, { email, password });
}

export function logout() {
  return axios.post('/logout');
}

// Server should return an object: { result: boolean }
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, { email });
}

export function resetPassword(password: string, token: string) {
  return axios.post<{ result: boolean }>(REQUEST_RESET_URL, {
    password,
    token,
  });
}

export function updateProfile(data: {
  name: string;
  phone: string;
  language: 'en' | 'pt';
}) {
  return axios.post<{ result: boolean }>(`${GET_USER_URL}/basic`, data);
}

export function updateEmail(data: {
  newEmail: string;
  confirmPassword: string;
}) {
  return axios.post<{ result: boolean }>(`${GET_USER_URL}/email`, data);
}

export function updatePassword(data: {
  currentPassword: string;
  newPassword: string;
  passwordConfirmation: string;
}) {
  return axios.post<{ result: boolean }>(`${GET_USER_URL}/password`, data);
}

export function getUser() {
  return axios.get<UserModel>(GET_USER_URL);
}
